import {
  setCookie,
  getCookie,
} from './utils'

const popupEmail = document.getElementById("email--popup");
const popupZipcode = document.getElementById('zipcode--popup');
var popup_email_value = '';
popupEmail.onkeyup = function() {
  var pattern = /\S+@\S+\.\S+/;
  if (pattern.test(popupEmail.value)) {
    popup_email_value = popupEmail.value;
  } else {
    popup_email_value = '';
  }
}
document.querySelector('.button--popup').addEventListener('click', function (e) {
  e.preventDefault();

  console.log(popupEmail.value);
  console.log(popupZipcode.value);

  if(popupEmail.value != '' && popupZipcode.value != '') {
    document.querySelector('.popup--email-capture__success').style.display = 'none';
    document.querySelector('.email-capture__form--popup #email--popup + .required').style.display = 'none';
    document.querySelector('.email-capture__form--popup #zipcode--popup + .required').style.display = 'none';
    fetch('https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:' + popupZipcode.value + '|country:USA&key=AIzaSyCCnCoGZ-IF04Srrq9mg_dTHbe1O2c_xzg')
    .then(res => res.json())
    .then(res => {
      console.log(res.status);
      if(res.status == 'OK') {
        console.log('submit to zaius');
        document.querySelector('.button--popup').classList.add('loading');

        zaius.event("consent", {
          action: "opt-in",
          email: popupEmail.value,
        });

        const options = {
          method: 'POST',
          headers: {Accept: 'application/json', 'Content-Type': 'application/json', 'x-api-key' : 'NyvrZ4C0MFiqrW04ZHCA0Q'},
          body: JSON.stringify({'email': popupEmail.value, list_id: 'bonnie', subscribed: true})
        };

        const optionsProfiles = {
          method: 'POST',
          headers: {Accept: 'application/json', 'Content-Type': 'application/json', 'x-api-key' : 'NyvrZ4C0MFiqrW04ZHCA0Q'},
          body: JSON.stringify({
            "attributes": {
            "email": popupEmail.value,
            "zip": popupZipcode.value,
            }
          })
        };

        fetch('https://api.zaius.com/v3/lists/subscriptions', options)
          .then(response => response.json())
          .then(function (response) {
            console.log(response)
            if(response.status != 400) {
              fetch('https://api.zaius.com/v3/profiles', optionsProfiles)
              .then(response => response.json())
              .then(function (response) {
                console.log(response)
                if(response.status != 400) {
                  document.querySelector('.popup--email-capture__success').style.display = 'block';
                  document.querySelector('.button--popup').classList.remove('loading');
                  popupEmail.value = '';
                  popupZipcode.value = '';
                }
              })
              .catch(err => console.error(err));
            }
          })
          .catch(err => console.error(err));


      } else {
        document.querySelector('.email-capture__form #zipcode--popup + .required').style.display = 'block';
      }
    });
  } else {
    document.querySelector('.popup--email-capture__success').style.display = 'none';
    if(popup_email_value == '' && popupZipcode.value == '') {
      document.querySelector('.email-capture__form--popup #email--popup + .required').style.display = 'block';
      document.querySelector('.email-capture__form--popup #zipcode--popup + .required').style.display = 'block';
    } else if (popup_email_value == '') {
      document.querySelector('.email-capture__form--popup #email--popup + .required').style.display = 'block';
      document.querySelector('.email-capture__form--popup #zipcode--popup + .required').style.display = 'none';
    } else if(popupZipcode.value == '') {
      document.querySelector('.email-capture__form--popup #email--popup + .required').style.display = 'none';
      document.querySelector('.email-capture__form--popup #zipcode--popup + .required').style.display = 'block';
    }
  }

});

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    var popupShownSession = sessionStorage.getItem('popupShown')
    var visits

    if(getCookie('visits')) {
      visits = parseInt(getCookie('visits')) + 1
    } else {
      visits = 0
    }

    setCookie('visits', visits, 1)

    if(popupShownSession != 'shown' && visits < 2 && getCookie('closed') != 'yes'){
      document.getElementById('shopify-section-email-capture-popup').classList.add('popup--active')
      sessionStorage.setItem('popupShown', 'shown')
    }
  }, 10000);

  const closePopup = () => {
    document.getElementById('shopify-section-email-capture-popup').classList.remove("popup--active");
    document.getElementById('shopify-section-email-capture-popup').setAttribute("aria-hidden", true);
    setCookie('closed', 'yes', 1)
  };
  document.querySelectorAll(".popup__close-button").forEach((button) => {
    button.addEventListener("click", () => {
      closePopup();
    });
  });
  document.querySelectorAll(".popup__overlay").forEach((overlay) => {
    overlay.addEventListener("click", () => {
      closePopup();
    });
  });
  document.addEventListener("keydown", (e) => {
    if (e.keyCode == 27) {
      closePopup();
    }
  });
});
